import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';


import { kratosApi } from './kratos/common';


export default function ErrorStatus(props: ErrorStatusProps) {
  return (
    <div>
      An error occurred.
      { props.message ? (<div>{ props.message }</div>) : null }
    </div>
  );
}


interface ErrorStatusProps {
  message?: string;
}


/*
    The error types part of the Kratos API seems to currently be 
    a sharp corner in terms of types and consistency.
    As best as I can tell, api.ts SelfServiceError.error is supposed to
    correspond to the idealized, generalized error at the following URL,
    but actual mileage varies, and TS support in the generated SDK seems..
    incomplete.
    https://www.ory.sh/docs/kratos/self-service/flows/user-facing-errors
*/
interface KratosError {
  code?: number;
  status?: string;
  reason?: string;
  message?: string;
}


function useErrorLookup(errorId: string) {
  return useQuery({
    queryKey: ['kratos', 'fetch-error', errorId],
    queryFn: async function doFetch({ queryKey: [_kratos, _fetchError, id] }) {
      return await kratosApi.getFlowError({ id });
    }
  });
}


export function ErrorLookup() {
  const [ searchParams,  ] = useSearchParams();
  const errorId = searchParams.get("id") || '';
  const query = useErrorLookup(errorId);
  let message: string = '';
  if (query.isSuccess && query.data && query.data.data.error) {
    // FlowError.error is just a generic 'object' in SDK (v1.2.0) so
    // cast it and grasp about for some usable string.. it appears like
    // .error is often an instance of GenericError?:
    const error = query.data.data.error as any;
    message = error?.message || error?.reason || '';
  }

  return (
    <ErrorStatus message={message} />
  );
}
